import { Black, Blue, Gray, White } from "./client-color";

// 主题色
const Theme = {
  "theme-1": Black["black-4"],
};

// 字体色
const ColorText = {
  "color-text-1": White["white-11"],
  "color-text-2": Gray["gray-2"],
  "color-text-3": Gray["gray-3"],
  "color-text-4": Blue["blue-9"],
  "color-text-5": Blue["blue-6"],
  "color-text-6": Blue["blue-10"],
  "color-text-7": Blue["blue-8"],
  "color-text-8": Blue["blue-7"],
  "color-text-9": Blue["blue-6"],
};

// 填充色
const ColorFill = {
  "color-fill-1": Black["black-2"],
  "color-fill-2": Black["black-6"],
  "color-fill-3": Black["black-3"],
  "color-fill-4": Black["black-5"],
  "color-fill-5": Black["black-1"],
  "color-fill-6": Black["black-8"],
  "color-fill-7": Black["black-7"],
  "color-fill-8": Black["black-10"],
  "color-fill-9": Blue["blue-8"],
  "color-fill-10": Blue["blue-10"],
  "color-fill-11": Black["black-1"],
  "color-fill-12": Blue["blue-13"],
  "color-fill-13": White["white-11"],
};

// 描边色
const ColorLine = {
  "color-line-1": Black["black-9"],
  "color-line-2": Black["black-9"],
};

// 渐变
const ColorGradient = {
  "gradient-fill-1":
    "linear-gradient(0.85deg, #353942 -19.46%, #525866 148.62%)",
  "gradient-fill-2": "linear-gradient(59.07deg, #3CC0EA 16.62%, #3C7BEA 79%)",
  "gradient-fill-3": "rgba(111, 111, 111, 0.87)",
  "gradient-fill-4":
    "linear-gradient(180deg, rgba(40, 109, 247, 0.34902) 0%, rgba(40, 109, 247, 0.0001) 99.88%)",
  "gradient-fill-5": "linear-gradient(0deg, #525866 -3.63%, #353942 101.21%)",
  "gradient-fill-6":
    "linear-gradient(204.78deg, #2C99FD 17.8%, #58B9FF 43.39%, #75FFFF 89.55%)",
  "gradient-fill-7":
    "linear-gradient(0deg, rgba(28, 30, 32, 0.02) 0%, rgba(28, 30, 32, 0.2) 100%)",
};

// 阴影
const ColorShadow = {
  "shadow-1": "0px 2px 19px 0px rgba(43, 53, 61, 0.39)",
  "shadow-2": "0px -2px 8px 2px rgba(12, 14, 17, 0.3) inset",
};

export default {
  ...Theme,
  ...ColorText,
  ...ColorFill,
  ...ColorLine,
  ...ColorGradient,
  ...ColorShadow,
};
